/**
 * ALLIN Product Actions
 * Self-contained handlers for the "Teilen" share button + "Frage zum Produkt" modal.
 * Does not depend on the theme's <share-button>, <modal-opener>, or <modal-dialog>.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:absolute;left:-9999px;top:-9999px;opacity:0;';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  function initShare(root) {
    var trigger = root.querySelector('[data-allin-share-trigger]');
    var panel = root.querySelector('[data-allin-share-panel]');
    var copyBtn = root.querySelector('[data-allin-share-copy]');
    var urlInput = root.querySelector('[data-allin-share-url]');
    var success = root.querySelector('[data-allin-share-success]');
    if (!trigger || !panel) return;

    var successTimer = null;

    function open() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (success) success.hidden = true;
    }
    function close() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
    function showSuccess() {
      if (!success) return;
      success.hidden = false;
      if (successTimer) clearTimeout(successTimer);
      successTimer = setTimeout(function () { success.hidden = true; }, 1800);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // On mobile, prefer native share if available
      if (navigator.share && window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
        navigator.share({ url: urlInput ? urlInput.value : location.href, title: document.title }).catch(function () {});
        return;
      }
      if (panel.hidden) open(); else close();
    });

    if (copyBtn && urlInput) {
      copyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var text = urlInput.value;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text)
            .then(showSuccess)
            .catch(function () { if (fallbackCopy(text)) showSuccess(); });
        } else if (fallbackCopy(text)) {
          showSuccess();
        }
      });
    }

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !root.contains(e.target)) close();
    });
    // Close on ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  }

  function initQuestionModal() {
    var modal = document.querySelector('[data-allin-question-modal]');
    if (!modal) return;

    // Move modal to body so it escapes any stacking-context / overflow ancestor.
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var openers = document.querySelectorAll('[data-allin-question-open]');
    var closers = modal.querySelectorAll('[data-allin-question-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var first = modal.querySelector('input, textarea');
      if (first) setTimeout(function () { first.focus(); }, 60);
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    closers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    // Auto-reopen after a successful contact form submission.
    if (window.__allinContactPosted) open();
  }

  ready(function () {
    document.querySelectorAll('[data-allin-share]').forEach(initShare);
    initQuestionModal();
  });
})();
